import React from "react";
import MissionImg from "../../assets/img/about-us/mission.jpeg";
const Mission = () => {
    return (
    
        <div className="container p-5 my-4">
          <div className="row ">
            {/* Text Content */}
            <div className="col-md-6 text-dark ">
              <h5 className="display-6 pb-2 mb-4">
                Mission
              </h5>
              <p>
              To provide a transparent auction marketplace that connects with Singapore’s car enthusiast community with a variety of vehicles, 
              upholding equality in all transactions.
            </p>
            </div>
            {/* Image Content */}
            <div className="col-md-6 text-center">
              <img
                src={MissionImg}
                alt="Car Marketplace"
                className="img-fluid rounded shadow-lg"
                style={{ maxWidth: "80%", height: "auto" }}
              />
            </div>
          </div>
          </div>
        
      
    );
  };
  
  export default Mission;